import { render, staticRenderFns } from "./VouchersDashboard.vue?vue&type=template&id=0f6a9e26&"
import script from "./VouchersDashboard.vue?vue&type=script&lang=js&"
export * from "./VouchersDashboard.vue?vue&type=script&lang=js&"
import style0 from "./VouchersDashboard.vue?vue&type=style&index=0&id=0f6a9e26&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f6a9e26')) {
      api.createRecord('0f6a9e26', component.options)
    } else {
      api.reload('0f6a9e26', component.options)
    }
    module.hot.accept("./VouchersDashboard.vue?vue&type=template&id=0f6a9e26&", function () {
      api.rerender('0f6a9e26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/Vouchers/VouchersDashboard.vue"
export default component.exports